function ensureGlobalGalleryImagesEager($scope) {
    const scope = $scope && $scope.length ? $scope : $('.productView');

    scope.find('[data-global-fallback] img').each((index, img) => {
        img.setAttribute('loading', 'eager');
        img.classList.remove('lazyload');

        const dataSrc = img.getAttribute('data-src');

        if (dataSrc && !img.getAttribute('src')) {
            img.setAttribute('src', dataSrc);
            img.removeAttribute('data-src');
        }

        const dataSrcset = img.getAttribute('data-srcset');

        if (dataSrcset && !img.getAttribute('srcset')) {
            img.setAttribute('srcset', dataSrcset);
            img.removeAttribute('data-srcset');
        }

        if (img.src && !img.complete) {
            const preload = new Image();
            preload.src = img.src;
        }
    });
}

window.ensureGlobalGalleryImagesEager = ensureGlobalGalleryImagesEager;

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.isFullWidth = this.item.is('.layout-4');

        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantInit(){
        this.updateOptions();
        this.updateMasterId();
        if (!(window.variantImagesMap && this.item.find('[data-variant-gallery-nav]').length)) {
            this.updateMedia(1500);
        }
        // this.updateURL();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        if (!this.currentVariant) {
            this.updateAttribute(true);
        } else {
            this.updateAttribute(false, !this.currentVariant.available);
        }
        this.updateVariantStatuses();
    }
    
    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateVariantStatuses();
      
        if (!this.currentVariant) {
            this.updateAttribute(true);
            this.updateStickyAddToCart(true);
        } else {
            this.updateMedia(200);
            if (!document.querySelector('.featured-product')) {
                this.updateURL();
            }
            this.updateVariantInput();
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateStickyAddToCart(false, !this.currentVariant.available);
            this.checkQuantityWhenVariantChange();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }
    
    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });

        if (this.item.find('[data-filter]').length && this.currentVariant?.featured_media && this.currentVariant.featured_media.alt != null) {
            this.item.find('[data-filter]:checked').attr('data-value-default-lang', this.currentVariant?.featured_media.alt.toLowerCase().replace(/ /g,"-"));
        }
    }      

    updateMedia(time) {
        if (window.variantImagesMap && this.item.find('[data-variant-gallery-nav]').length) {
            if (this.currentVariant) {
                this.updateVariantMetafieldGallery(String(this.currentVariant.id));
            }
            return;
        }

        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        window.setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);

        if (!this.isFullWidth || window.innerWidth < 768) return;

        const mediaToReplace = document.querySelector('.productView-image[data-index="1"]');
        const imageToReplace = mediaToReplace.querySelector('img');

        if (!this.currentVariant) return;

        const image = this.currentVariant?.featured_image;

        if (image == null) return;

        imageToReplace.setAttribute('src', image.src);
        imageToReplace.setAttribute('srcset', image.src);
        imageToReplace.setAttribute('alt', image.alt);

        if (mediaToReplace.getBoundingClientRect().top < window.scrollY) {
            this.scrollToBlock(mediaToReplace);
        }
    }

    goToVariantGalleryStart() {
        const sliderNav = this.item.find('[data-variant-gallery-nav]');
        const sliderFor = this.item.find('[data-variant-gallery-thumb]');

        if (typeof halo !== 'undefined' && typeof halo.syncVariantGallerySliders === 'function') {
            halo.syncVariantGallerySliders(this.item, sliderNav, sliderFor, 0);
        }
    }

    getOrderedVariantImages(variantId) {
        const imagesMap = window.variantImagesMap;
        const featuredMap = window.variantFeaturedImagesMap;

        const normalizeImageUrl = (url) => {
            if (!url) {
                return '';
            }

            return url.split('?')[0];
        };

        const getImageBasename = (url) => {
            if (!url) {
                return '';
            }

            const path = url.split('?')[0];
            const parts = path.split('/');

            return parts[parts.length - 1].toLowerCase();
        };

        const isSameImage = (imageA, imageB) => {
            if (!imageA || !imageB) {
                return false;
            }

            const urlA = normalizeImageUrl(imageA.url);
            const urlB = normalizeImageUrl(imageB.url);
            const basenameA = imageA.basename || getImageBasename(imageA.url);
            const basenameB = imageB.basename || getImageBasename(imageB.url);

            if (urlA && urlB && urlA === urlB) {
                return true;
            }

            if (basenameA && basenameB && basenameA === basenameB) {
                return true;
            }

            return false;
        };

        const metafieldImages = (imagesMap && imagesMap[variantId]) ? imagesMap[variantId].slice() : [];
        const featuredImage = featuredMap && featuredMap[variantId] ? featuredMap[variantId] : null;

        if (!featuredImage) {
            return metafieldImages;
        }

        const additionalImages = metafieldImages.filter((image) => {
            return !isSameImage(image, featuredImage);
        });

        return [featuredImage].concat(additionalImages);
    }

    updateVariantMetafieldGallery(variantId) {
        const config = window.variantGalleryConfig;
        const imagesMap = window.variantImagesMap;

        if (!config || !imagesMap || !this.item.find('[data-variant-gallery-nav]').length) {
            return;
        }

        const variantImages = this.getOrderedVariantImages(variantId);
        const sliderNav = this.item.find('[data-variant-gallery-nav]');
        const sliderFor = this.item.find('[data-variant-gallery-thumb]');
        const navTemplate = document.getElementById('GlobalGalleryNav-' + config.sectionId);
        const thumbTemplate = document.getElementById('GlobalGalleryThumb-' + config.sectionId);

        const normalizeImageUrl = (url) => {
            if (!url) {
                return '';
            }
            return url.split('?')[0];
        };

        const getImageBasename = (url) => {
            if (!url) {
                return '';
            }
            const path = url.split('?')[0];
            const parts = path.split('/');
            return parts[parts.length - 1].toLowerCase();
        };

        const allVariantUrlSet = [];
        const allVariantBasenameSet = [];

        Object.keys(imagesMap).forEach((mapVariantId) => {
            if (mapVariantId === 'productFallbackImages') {
                return;
            }

            const mapImages = imagesMap[mapVariantId] || [];

            mapImages.forEach((image) => {
                allVariantUrlSet.push(normalizeImageUrl(image.url));
                allVariantBasenameSet.push(image.basename || getImageBasename(image.url));
            });
        });

        const featuredMap = window.variantFeaturedImagesMap || {};

        Object.keys(featuredMap).forEach((mapVariantId) => {
            const featuredImage = featuredMap[mapVariantId];

            if (!featuredImage) {
                return;
            }

            allVariantUrlSet.push(normalizeImageUrl(featuredImage.url));
            allVariantBasenameSet.push(featuredImage.basename || getImageBasename(featuredImage.url));
        });

        const excludeMediaIds = (config.excludeMediaIds || []).map((mediaId) => {
            return String(mediaId);
        });

        const isVariantAssignedImage = (url, basename) => {
            const normalized = normalizeImageUrl(url);
            const normalizedBasename = basename || getImageBasename(url);

            if (normalized && allVariantUrlSet.some((variantUrl) => {
                return variantUrl === normalized;
            })) {
                return true;
            }

            if (normalizedBasename && allVariantBasenameSet.some((variantBasename) => {
                return variantBasename === normalizedBasename;
            })) {
                return true;
            }

            return false;
        };

        const isProductFeaturedImage = (url, basename, shopifyMediaId) => {
            if (config.productFeaturedMediaId && shopifyMediaId && String(shopifyMediaId) === String(config.productFeaturedMediaId)) {
                return true;
            }

            const normalized = normalizeImageUrl(url);
            const normalizedBasename = basename || getImageBasename(url);

            if (config.productFeaturedBasename && normalizedBasename === config.productFeaturedBasename) {
                return true;
            }

            if (config.productFeaturedUrl && normalized === normalizeImageUrl(config.productFeaturedUrl)) {
                return true;
            }

            return false;
        };

        const getTemplateMarkup = (templateEl) => {
            if (!templateEl) {
                return '';
            }

            if (templateEl.content && templateEl.content.childNodes.length) {
                const markupWrapper = document.createElement('div');
                markupWrapper.appendChild(templateEl.content.cloneNode(true));
                return markupWrapper.innerHTML;
            }

            return templateEl.innerHTML || '';
        };

        const filterGlobalSlides = (templateEl) => {
            const templateMarkup = getTemplateMarkup(templateEl);

            if (!templateMarkup) {
                return '';
            }

            const wrapper = document.createElement('div');
            wrapper.innerHTML = templateMarkup;

            wrapper.querySelectorAll('[data-global-fallback]').forEach((slide) => {
                const dedupUrl = slide.getAttribute('data-dedup-url');
                const dedupBasename = slide.getAttribute('data-dedup-basename');
                const shopifyMediaId = slide.getAttribute('data-shopify-media-id');

                if (shopifyMediaId && excludeMediaIds.includes(String(shopifyMediaId)) && !isProductFeaturedImage(dedupUrl, dedupBasename, shopifyMediaId)) {
                    slide.remove();
                    return;
                }

                if (dedupUrl || dedupBasename) {
                    const isFeatured = isProductFeaturedImage(dedupUrl, dedupBasename, shopifyMediaId);

                    if (isFeatured && variantImages.length > 0) {
                        slide.remove();
                        return;
                    }

                    if (!isFeatured && isVariantAssignedImage(dedupUrl, dedupBasename)) {
                        slide.remove();
                    }
                }
            });

            wrapper.querySelectorAll('[data-global-fallback] img').forEach((img) => {
                img.setAttribute('loading', 'eager');
                img.classList.remove('lazyload');

                const dataSrc = img.getAttribute('data-src');

                if (dataSrc && !img.getAttribute('src')) {
                    img.setAttribute('src', dataSrc);
                    img.removeAttribute('data-src');
                }
            });

            return wrapper.innerHTML;
        };

        const buildVariantNavSlides = () => {
            let html = '';
            const mediaSize = config.mediaSize;
            const mediaFit = config.mediaFit;
            const portraitRatio = config.portraitAspectRatio;

            variantImages.forEach((image, index) => {
                const slideIndex = index + 1;
                let paddingStyle = '';

                if (mediaFit !== 'unset') {
                    if (mediaSize === 'adapt' && image.width && image.height) {
                        paddingStyle = ' style="padding-bottom: ' + ((image.height / image.width) * 100) + '%;"';
                    } else if (mediaSize === 'square') {
                        paddingStyle = ' style="padding-bottom: 100%;"';
                    } else if (mediaSize === 'portrait' && portraitRatio) {
                        paddingStyle = ' style="padding-bottom: ' + portraitRatio + ';"';
                    }
                }

                const zoomAttrs = config.zoomedImage && !config.mainImageShowCustomCursor
                    ? ' data-zoom-image="' + image.masterUrl + '"'
                    : '';
                const fancyboxAttrs = config.fancyboxEnabled
                    ? ' data-fancybox="images" href="' + image.masterUrl + '"'
                    : '';

                html += '<div class="productView-image productView-image-' + mediaSize + ' fit-' + mediaFit + '" data-index="' + slideIndex + '" data-variant-id="' + variantId + '" data-dedup-url="' + image.url + '" data-dedup-basename="' + (image.basename || getImageBasename(image.url)) + '">' +
                    '<div class="productView-img-container product-single__media" data-media-id="variant-' + variantId + '-' + image.fileId + '"' + paddingStyle + '>' +
                    '<div class="media"' + zoomAttrs + fancyboxAttrs + '>' +
                    '<img id="product-variant-image-' + variantId + '-' + slideIndex + '"' +
                    ' srcset="' + image.url + ' 1200w, ' + image.masterUrl + ' 2000w"' +
                    ' src="' + image.url + '"' +
                    ' alt="' + (image.alt || '').replace(/"/g, '&quot;') + '"' +
                    ' sizes="(min-width: 2000px) 1500px, (min-width: 1200px) 1200px, (min-width: 768px) calc((100vw - 30px) / 2), calc(100vw - 20px)"' +
                    ' width="' + image.width + '"' +
                    ' height="' + image.height + '"' +
                    ' data-sizes="auto"' +
                    ' data-main-image' +
                    ' data-index="' + slideIndex + '"' +
                    ' data-cursor-image' +
                    ' data-variant-image-url="' + image.url + '"' +
                    ' loading="eager"' +
                    ' />' +
                    '</div></div></div>';
            });

            return html;
        };

        const buildVariantThumbSlides = () => {
            let html = '';

            variantImages.forEach((image, index) => {
                const activeClass = index === 0 ? ' pdp-gallery-thumb-active' : '';
                html += '<div class="productView-thumbnail' + activeClass + '" data-media-id="' + config.sectionId + '-variant-' + variantId + '-' + image.fileId + '" data-variant-id="' + variantId + '" data-dedup-url="' + image.url + '" data-dedup-basename="' + (image.basename || getImageBasename(image.url)) + '">' +
                    '<div class="productView-thumbnail-link" data-image="' + image.largeThumbUrl + '">' +
                    '<img srcset="' + image.thumbUrl + '" src="' + image.thumbUrl + '" alt="' + (image.alt || '').replace(/"/g, '&quot;') + '" data-variant-image-url="' + image.thumbUrl + '" />' +
                    '</div></div>';
            });

            return html;
        };

        const globalNavHtml = filterGlobalSlides(navTemplate);
        const globalThumbHtml = filterGlobalSlides(thumbTemplate);
        const navHtml = buildVariantNavSlides() + globalNavHtml;
        let thumbHtml = buildVariantThumbSlides() + globalThumbHtml;

        if (variantImages.length === 0 && globalThumbHtml) {
            const tempThumb = document.createElement('div');
            tempThumb.innerHTML = globalThumbHtml;
            const firstThumb = tempThumb.querySelector('.productView-thumbnail');

            if (firstThumb) {
                firstThumb.classList.add('pdp-gallery-thumb-active');
            }

            thumbHtml = tempThumb.innerHTML;
        }

        const tempNav = document.createElement('div');
        tempNav.innerHTML = navHtml;
        const slideCount = tempNav.querySelectorAll('.productView-image').length;

        tempNav.querySelectorAll('.productView-image').forEach((slide, index) => {
            slide.setAttribute('data-index', String(index + 1));
            const img = slide.querySelector('[data-main-image]');

            if (img) {
                img.setAttribute('data-index', String(index + 1));
            }
        });

        if (typeof halo !== 'undefined' && typeof halo.destroyVariantGallerySliders === 'function') {
            halo.destroyVariantGallerySliders(sliderNav, sliderFor);
        } else {
            [sliderNav, sliderFor].forEach(($slider) => {
                if ($slider.hasClass('slick-initialized')) {
                    try {
                        $slider.slick('unslick');
                    } catch (error) {
                        $slider.removeClass('slick-initialized');
                    }

                    $slider.off('init reInit beforeChange afterChange');
                }
            });
        }

        sliderNav.attr('data-media-count', slideCount);
        sliderNav.html(tempNav.innerHTML);
        sliderFor.html(thumbHtml);
        sliderFor.attr('data-thumb-count', sliderFor.children('.productView-thumbnail').length);
        ensureGlobalGalleryImagesEager(this.item);

        if (typeof halo !== 'undefined' && typeof halo.productImageGallery === 'function') {
            halo.productImageGallery(this.item, true);
        }

        const thumbWrapper = sliderFor.parent();
        const thumbSlideCount = sliderFor.children('.productView-thumbnail').length;
        const thumbnailToShow = parseInt(sliderFor.data('max-thumbnail-to-show'), 10) || config.maxThumbnailToShow || 4;
        const showThumbArrows = thumbSlideCount > thumbnailToShow && window.innerWidth > 1279;

        thumbWrapper.attr('data-show-thumb-arrows', showThumbArrows ? 'true' : 'false');

        if (showThumbArrows) {
            thumbWrapper.addClass('arrows-visible').removeClass('arrows-disable');
        } else {
            thumbWrapper.addClass('arrows-disable').removeClass('arrows-visible');
        }

        this.goToVariantGalleryStart();
        this._reinitZoom();
    }

    scrollToBlock(block) {
        const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height
        const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height
        const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight

        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
        })
    }

    _reinitZoom() {
        const config = window.variantGalleryConfig;
        if (!config || !config.zoomedImage || config.mainImageShowCustomCursor) return;
        if (window.innerWidth <= 1024) return;
        if (typeof $.fn.zoom !== 'function') return;

        const $scope = this.item;
        const sliderNav = this.item.find('[data-variant-gallery-nav]');

        $scope.find('[data-zoom-image]').each(function () {
            $(this).trigger('zoom.destroy');
        });

        if (sliderNav.hasClass('slick-initialized')) {
            let $target = sliderNav.find('.slick-slide.slick-current:not(.slick-cloned) [data-zoom-image]').first();
            if (!$target.length) {
                $target = sliderNav.find('.slick-slide:not(.slick-cloned) [data-zoom-image]').first();
            }
            if ($target.length) {
                $target.zoom({ url: $target.attr('data-zoom-image'), touch: false });
            }
        } else {
            // Native scroll: init zoom on every slide so hover works regardless of which is visible
            sliderNav.find('[data-zoom-image]').each(function () {
                const $el = $(this);
                $el.zoom({ url: $el.attr('data-zoom-image'), touch: false });
            });
        }
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    _applySectionHtml(responseText) {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Price
                const id = `product-price-${this.dataset.product}`;
                const destination = document.getElementById(id);
                const source = html.getElementById(id);
        if (source && destination) {
            destination.innerHTML = source.innerHTML;
        }

        // Property
                const property = `product-property-${this.dataset.product}`;
                const destinationProperty = document.getElementById(property);
                const sourceProperty = html.getElementById(property);
        if (destinationProperty) {
            if (sourceProperty) {
                destinationProperty.innerHTML = sourceProperty.innerHTML;
                destinationProperty.style.display = 'table';
            } else {
                destinationProperty.style.display = 'none';
            }
        } else if (sourceProperty) {
            document.querySelector('.productView-product').insertBefore(sourceProperty, document.querySelector('.productView-options'));
        }

        // Description — merged here to avoid a second fetch call
        const descSelector = `[data-product-description-${this.dataset.product}]`;
        const destinationDesc = document.querySelector(descSelector);
        const sourceDesc = html.querySelector(descSelector);
        if (sourceDesc && destinationDesc) {
            destinationDesc.innerHTML = sourceDesc.innerHTML;
            if (destinationDesc.closest('.toggle-content--height')) {
                destinationDesc.style.maxHeight = null;
            }
                }

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

        document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
        this.updateBadgeSale();
    }

    renderProductAjaxInfo() {
        const variantId = String(this.currentVariant.id);
        const priceEl = document.getElementById(`product-price-${this.dataset.product}`);
        const propertyEl = document.getElementById(`product-property-${this.dataset.product}`);
        const descEl = document.querySelector(`[data-product-description-${this.dataset.product}]`);

        // No section-fetch-dependent elements exist (e.g. combo-product PDPs) —
        // skip the network fetch entirely and drive everything from preloaded data.
        if (!priceEl && !propertyEl && !descEl) {
            if (this.checkNeedToConvertCurrency()) {
                const cc = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, cc, 'span.money', 'money_format');
            }
            this.updateBadgeSale();
            return;
        }

        // Price element exists, no property/description — update from preloaded map.
        if (priceEl && !propertyEl && !descEl && window.variantPriceDataMap?.[variantId]) {
            this._applyPriceFromMap(priceEl, variantId);
            priceEl.classList.remove('visibility-hidden');
            if (this.checkNeedToConvertCurrency()) {
                const cc = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, cc, 'span.money', 'money_format');
            }
            this.updateBadgeSale();
            return;
        }

        // Fallback: fetch the section HTML (handles property/description elements
        // and products without preloaded price data).
        const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`;
        if (this._sectionHtmlCache.has(variantId)) {
            this._applySectionHtml(this._sectionHtmlCache.get(variantId));
            return;
        }
        if (this._sectionFetchController) {
            this._sectionFetchController.abort();
        }
        this._sectionFetchController = new AbortController();
        const { signal } = this._sectionFetchController;
        fetch(url, { signal })
            .then((response) => response.text())
            .then((responseText) => {
                this._sectionHtmlCache.set(variantId, responseText);
                if (String(this.currentVariant?.id) === variantId) {
                    this._applySectionHtml(responseText);
                }
            })
            .catch((err) => {
                if (err.name !== 'AbortError') throw err;
            });
    }

    _applyPriceFromMap(priceEl, variantId) {
        const d = window.variantPriceDataMap[variantId];
        const container = priceEl.querySelector('.price');
        if (!container || !d) return;

        const isOnSale = d.compareAtPrice > d.price;
        container.classList.toggle('price--on-sale', isOnSale);
        container.classList.remove('price--sold-out');

        const regularSpan = container.querySelector('.price__regular .price-item');
        if (regularSpan) regularSpan.innerHTML = d.priceF;

        const saleLast = container.querySelector('.price__sale .price__last');
        if (saleLast) {
            saleLast.setAttribute('data-last', String(d.price));
            const saleSpan = saleLast.querySelector('.price-item');
            if (saleSpan) saleSpan.innerHTML = d.priceF;
        }

        const compareEl = container.querySelector('.price__sale .price__compare');
        if (compareEl) {
            if (isOnSale && d.compareF) {
                compareEl.setAttribute('data-compare', String(d.compareAtPrice));
                const compareS = compareEl.querySelector('.price-item');
                if (compareS) compareS.innerHTML = d.compareF;
            } else {
                compareEl.removeAttribute('data-compare');
            }
        }
    }

    renderProductInfo() {
        if(this.item.find('[data-sku]').length > 0){
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
        }

        if(this.item.find('[data-barcode]').length > 0){
            this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode);
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inputQuantity = this.item.find('input[name="quantity"]'),
                    buttonSubmit = this.item.find('button#product-add-to-cart'),
                    inventoryQuantity = parseInt(inven_num);

                if(inputQuantity.length > 0) {
                    inputQuantity.attr('data-inventory-quantity', inventoryQuantity);
                } else {
                    buttonSubmit.attr('data-inventory-quantity', inventoryQuantity);
                }

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        const showStock = this.item.find('[data-inventory]').data('stock-level');
                        if (showStock == 'show') {
                            this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
                        }
                        else {
                            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                        }
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }

                hotStock(inventoryQuantity);
            }
        }

        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const optionSticky = sticky.find('.select__select');

            optionSticky.val(this.currentVariant.id);
        }
    }

    updateProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const description = `[data-product-description-${this.dataset.product}]`
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destinationDesc = document.querySelector(description);
                const sourceDesc = html.querySelector(description);

                if (sourceDesc && destinationDesc) {
                    destinationDesc.innerHTML = sourceDesc.innerHTML;
                    if (destinationDesc.closest('.toggle-content--height')){
                        destinationDesc.style.maxHeight = null;
                    }
                }
        });
    }

    updateAttribute(unavailable = true, disable = true){
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        var quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.productView-notifyMe'),
            hotStock = this.item.find('.productView-hotStock'),
            buttonAddtocart = this.item.find('.product-form__submit'),
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (isNaN(maxValue)) {
            maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
        } else {
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
        }
        
        if(unavailable){
            var text = window.variantStrings.unavailable;

            quantityInput.attr('disabled', true);
            notifyMe.slideUp('slow');
            addButton.setAttribute('disabled', true);
            addButton.textContent = text;
            quantityInput.closest('quantity-input').addClass('disabled');

            if(hotStock.length > 0) hotStock.addClass('is-hiden');
        } else {
            if (disable) {
                var text = window.variantStrings.soldOut,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }
                    } else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                        console.log(text,'123');
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', true);
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
                quantityInput.closest('quantity-input').addClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else {
                var text,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }

                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.variantStrings.addToCart;
                        }
                    } else if (window.subtotal.style == '2') {
                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.subtotal.text.replace('[value]', subTotal);
                            $('#show-sticky-product').text(text);
                            $('#product-sticky-add-to-cart').text(text);
                            console.log(text,'345');
                        }
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', false);
                addButton.removeAttribute('disabled');
                addButton.textContent = text;
                quantityInput.closest('quantity-input').removeClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');
                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.slideUp('slow');
                }
            }
        }
    }

    updateStickyAddToCart(unavailable = true, disable = true){
        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const itemImage = sticky.find('.sticky-image');
            const option = sticky.find('.select__select');
            const input = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('input[name="id"]');
            const button = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
            var quantityInput = this.item.find('input[name="quantity"]');
            var maxValue;

            if (quantityInput.length > 0) {
                maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
            } else {
                maxValue = parseInt(submitBtn.attr('data-inventory-quantity'));
            }
          
            if(unavailable){
                var text = window.variantStrings.unavailable;

                button.setAttribute('disabled', true);
                button.textContent = text;
            } else {
                if (!this.currentVariant) return;

                const image = this.currentVariant?.featured_image;
                
                if (image != null) {
                    itemImage.find('img').attr({
                        'src': image.src,
                        'srcset': image.src,
                        'alt': image.alt
                    });
                }

                option.val(this.currentVariant.id);

                if (disable) {
                    var text = window.variantStrings.soldOut;

                    button.setAttribute('disabled', true);
                    button.textContent = text;
                } else {
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }

                    button.removeAttribute('disabled');
                    button.textContent = text;
                }

                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
        var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
        var inputValue = parseInt(quantityInput?.value);

        let value = inputValue 

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1 
      
        if (quantityInput) {
          quantityInput.value = value
        }
      
        document.getElementById('product-add-to-cart').dataset.available = this.currentVariant.available && maxValue <= 0
    }

    updateVariantStatuses() {
        // const options = this.item.find('.productView-details .product-form__input'),
        //     optionsLength = options.length,
        //     pvOptionsLength = PVoptions.length,
        //     checkStickyVariant = false;
      
        // optionsLength > pvOptionsLength ? checkStickyVariant = true : '';

        const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        const inputLength = inputWrappers.length;
        const variant_swatch = [...this.querySelectorAll('.product-form__swatch')];
        inputWrappers.forEach((option, index) => {
            option.querySelector('[data-header-option]').innerText = option.querySelector(':checked').value;
            if (index === 0 && inputLength > 1) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputLength > 1 ? inputWrappers[index - 1].querySelector(':checked').value : inputWrappers[index].querySelector(':checked').value;
            const optionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.map(variantOption => variantOption[`option${ index + 1 }`]);
            const availableOptionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.filter(variant => variant.available).map(variantOption => variantOption[`option${ index + 1 }`]);
            this.setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue)
            if (variant_swatch.length > 1){
                this.updateImageSwatch(selectedOptionOneVariants)
            }
        });
    }

    updateImageSwatch(selectedOptionOneVariants) {
        const inputWrappers = this.querySelectorAll('.product-form__input');
        if(inputWrappers){
            inputWrappers.forEach((element, inputIndex) => {
                const imageSpan = element.querySelectorAll("label>span.pattern");
                const imageLabel = element.querySelectorAll("label");
                const imageSpanImage = element.querySelectorAll("label>span.expand>img");
                const inputList = element.querySelectorAll("input");

                inputList.forEach((item, index) => {
                    const image = selectedOptionOneVariants.filter(tmp => {
                        if (inputIndex == 0) return tmp.option1 == item.value;
                        if (inputIndex == 1) return tmp.option2 == item.value;
                        if (inputIndex == 2) return tmp.option3 == item.value;
                    });
    
                    if(image.length > 0) {
                        imageLabel[index].style.display = "inline-block";
                        if (imageSpan[index] != undefined && image[0].featured_image != null) imageSpan[index].style.backgroundImage = `url("${image[0].featured_image.src}")`;
                        if (imageSpanImage[index] != undefined && image[0].featured_image != null) imageSpanImage[index].srcset = image[0].featured_image.src;
                    }
                    // else {
                    //     imageLabel[index].style.display = "none";
                    // }
                })
            });
        }
    }            

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                input.classList.remove('soldout');
                input.innerText = input.getAttribute('value');
            } else {
                input.classList.add('soldout');
                optionInputsValue.includes(input.getAttribute('value')) ? input.innerText = input.getAttribute('value') + ' (Sold out)' : input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'))
            }
        });
    }

    updateBadgeSale() {
        const badgeWrap = document.querySelector('.productView-badge');
        const priceCompareEl = document.querySelector('.productView-product .price__compare');
        const priceLastEl = document.querySelector('.productView-product .price__sale .price__last');

        if (!badgeWrap || !priceCompareEl || !priceLastEl) {
            return;
        }

        const badgeText = badgeWrap.querySelector('.productView-badge .badge.sale-badge');
        const badgeTextSaleType = badgeWrap.getAttribute('data-text-sale-badge');
        const priceCompare = priceCompareEl.getAttribute('data-compare');
        const priceLast = priceLastEl.getAttribute('data-last');

        if (!priceCompare || !priceLast) {
            badgeWrap.querySelector('.badge.sale-badge')?.remove();
            return;
        }

        const percentSale = Math.round(((priceCompare - priceLast) / priceCompare) * 100);

        function renderSpan(text1, text2) {
            const spanElement = document.createElement('span');
            spanElement.classList.add('badge', 'sale-badge');
            const container = document.querySelector('.productView-badge');
            container.appendChild(spanElement);
            spanElement.innerText = `${text1} ${text2}%`;
        }

        if (badgeWrap.classList.contains("has-badge-js")) {
            if (!priceCompare) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
            } else {
                if (!badgeText) {
                    renderSpan(badgeTextSaleType, percentSale)
                } else {
                    badgeText.innerText = `${badgeTextSaleType} ${percentSale}%`
                }
            }
        } else {
            if (!priceCompare) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
            } else {
                if (!badgeText) {
                    renderSpan(badgeTextSaleType, percentSale);
                } else {
                    badgeText.innerText = `${badgeTextSaleType}`
                }
            }
        }

    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            if (input.tagName === 'OPTION') {
                return;
            }

            const label = input.nextElementSibling;

            if (!label || !label.classList) {
                return;
            }

            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                label.classList.remove('soldout', 'unavailable');
                label.classList.add('available');
            } else {
                label.classList.remove('available', 'unavailable');
                label.classList.add('soldout');

                if (window.variantStrings.hide_variants_unavailable && !optionInputsValue.includes(input.getAttribute('value'))) {
                    label.classList.add('unavailable');

                    if (!input.checked) {
                        return;
                    }

                    let inputsValue;
                    availableOptionInputsValue.length > 0 ? inputsValue = availableOptionInputsValue : inputsValue = optionInputsValue;
                    const fallbackInput = input.closest('.product-form__input').querySelector(`input[value="${inputsValue[0]}"]`);

                    if (fallbackInput) {
                        fallbackInput.checked = true;
                        this.dispatchEvent(new Event('change'));
                    }
                }
            }
        });
    }
        
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (!this.checkHasMultipleVariants()) {
            this.initProductQuantity();
            this.checkVariantInventory();
        }
    }

    onInputChange(event) {
        event.preventDefault(); 
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
        var saleOutStock  = document.getElementById('product-add-to-cart').dataset.available === 'true' || false ;
        const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }
        
        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];
          
            if(itemStatus == 'deny') {
              inputValue = maxValue
              this.input.value = inputValue;
              const message = getInputMessage(maxValue)
              showWarning(message, 3000)
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
            this.input.value = inputValue;
        }

        if(window.subtotal.show) {
            var text,
                price = this.input.dataset.price,
                subTotal = 0;

            var parser = new DOMParser();

            subTotal = inputValue * price;
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);

            const moneySpan = document.createElement('span')
            moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal') 
            moneySpan.innerText = subTotal 
            document.body.appendChild(moneySpan) 

            if (this.checkNeedToConvertCurrency()) {
                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }

            subTotal = moneySpan.innerText 
            $(moneySpan).remove()

            if (window.subtotal.style == '1') {
                const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');

                pdView_subTotal.textContent = subTotal;
            }
            else if (window.subtotal.style == '2') {
                text = window.subtotal.text.replace('[value]', subTotal);
                $('#product-sticky-add-to-cart').text(text);

                addButton.textContent = text;  
            }

            const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
            const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

            if (stickyPrice.length) {
                stickyPrice.text(subTotal);
            }

            if (stickyComparePrice.length && window.subtotal.show) {
                let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
                comparePrice = inputValue * comparePrice;
                comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                comparePrice = extractContent(comparePrice);
                stickyComparePrice.text(comparePrice);
            }
        }

        if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
            const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            mainQty.value = inputValue;

            const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
            const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

            if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
                const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
                mainQty3.value = inputValue;
            }
            else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
                const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
                mainQty2.value = inputValue;
            }
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }
    
    checkHasMultipleVariants() {
        const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
        this.inven_array = window[arrayInVarName];
        return Object.keys(this.inven_array).length > 1
    }
        
    initProductQuantity() {
        if(this.inven_array != undefined) {
            var inven_num = Object.values(this.inven_array),
                inventoryQuantity = parseInt(inven_num);

            this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
            this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
        }
    }

    checkVariantInventory() {
        const addBtn = document.getElementById('product-add-to-cart')
        this.input.disabled = addBtn.disabled 
        this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled
        this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('quantity-input', QuantityInput);

function hotStock(inventoryQuantity) {
    const productView = document.querySelector('.productView');
    const hotStock = productView.querySelector('.productView-hotStock');
    if(hotStock) {
        let hotStockText = hotStock.querySelector('.hotStock-text'),
            maxStock = parseFloat(hotStock.dataset.hotStock),
            textStock;

        if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
            hotStock.matches('.style-2') ? textStock  = window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity) : textStock  = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
            if (hotStockText) hotStockText.innerHTML = textStock;
            hotStock.classList.remove('is-hide');
        } else {
            hotStock.classList.add('is-hide');
        }

        if (hotStock.matches('.style-2')) {
            const invenProgress = inventoryQuantity / maxStock * 100,
                hotStockProgressItem = hotStock.querySelector('.hotStock-progress-item');
            if (hotStockProgressItem) hotStockProgressItem.style.width = `${invenProgress}%`;
        }
    }
}
const hotStockNoOptions = document.querySelector('.productView .productView-hotStock[data-current-inventory]');
if (hotStockNoOptions) {
    const inventoryQuantity = parseFloat(hotStockNoOptions.dataset.currentInventory);
    hotStock(inventoryQuantity);
}


function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}